<div class='center login-loading-component'>
	<mat-spinner class='mx-auto' diameter="50"></mat-spinner>
	<span class='h1 mb3 block'>Ingresando...</span>
</div>
